import './styles.scss'
import { useState } from 'react'
import Tracker from './Tracker'
import TrackItResult from './TrackItResult'
import { useInView } from '../../Hooks/useInView'

const TrackIt = () => {
  const [trackItResult, setTrackItResult] = useState(null)
  const [contentRef, contentInView] = useInView()

  return (
    <div className="track-it">
      <div className="track-it__top">
        <h1>Track Your Package</h1>
      </div>

      <div
        ref={contentRef}
        className={`track-it__content reveal fade-up${contentInView ? ' visible' : ''}`}
      >
        {!trackItResult ? (
          <Tracker setTrackItResult={setTrackItResult} />
        ) : (
          <TrackItResult
            trackItResult={trackItResult}
            onReset={() => setTrackItResult(null)}
          />
        )}
      </div>
    </div>
  )
}

export default TrackIt
